import { asLink, isFilled } from "@prismicio/helpers";
import { getPdp } from "../aws/commerce";
import { typedBoolean } from "../helper";
import { RedisCache } from "../redis/client";
const fetchFeaturedProducts = async (_paths, locale) => {
    const redisCache = new RedisCache();
    const paths = [...new Set(_paths)];
    const ids = await Promise.all(paths.map((path) => redisCache.getProductId(path, locale).catch(() => null)));
    const productsData = (await Promise.all(ids.filter(typedBoolean).map(({ id, path }) => {
        if (!id)
            return null;
        return getPdp(id)
            .then((product) => ({ product, path }))
            .catch(() => null);
    }))).filter(typedBoolean);
    const products = productsData
        .map(({ product, path }) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const name = (_c = (((_a = product.name) === null || _a === void 0 ? void 0 : _a[process.env.NEXT_PUBLIC_LOCALE]) || ((_b = product.name) === null || _b === void 0 ? void 0 : _b["en"]))) !== null && _c !== void 0 ? _c : "";
        if (!name)
            return;
        const isOnStock = (_e = (_d = product.sizeGroup) === null || _d === void 0 ? void 0 : _d.sizes) === null || _e === void 0 ? void 0 : _e.some((item) => item.isOnStock);
        if (!isOnStock)
            return;
        const price = product.price;
        if (!price)
            return;
        return {
            price,
            firstPrice: product.firstPrice || null,
            lowestPrice: product.lowestPrice || null,
            discountedPrice: product.discountedPrice || null,
            name,
            path: `/${path}`.replace(/^(\/*)/, "/"),
            isOnStock,
            attributes: product.attributes,
            promotionalBanner: ((_g = (_f = product.promotionalBanner) === null || _f === void 0 ? void 0 : _f.name) === null || _g === void 0 ? void 0 : _g[process.env.NEXT_PUBLIC_LOCALE]) || "",
            id: product.id,
        };
    })
        .filter(typedBoolean);
    return products;
};
export const buildFeaturedProducts = async (prismic, locale) => {
    var _a;
    if (!((_a = prismic.data.body) === null || _a === void 0 ? void 0 : _a.length))
        return [];
    const paths = [...prismic.data.body]
        .map((slice) => {
        switch (slice.slice_type) {
            case "featured_products":
            case "carousel_products":
                return slice.items.map((link) => {
                    if (!isFilled.link(link.product_link))
                        return "";
                    const url = asLink(link.product_link);
                    if (!url)
                        return "";
                    try {
                        return new URL(url).pathname.replace(/^\//, "");
                    }
                    catch {
                        return "";
                    }
                });
            default:
                return "";
        }
    })
        .filter(typedBoolean)
        .flat();
    return fetchFeaturedProducts(paths, locale);
};
